import { render } from "./Temporizador.vue?vue&type=template&id=fd0fe780&ts=true"
import script from "./Temporizador.vue?vue&type=script&lang=ts"
export * from "./Temporizador.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__